export const URL_API = "https://api.themoviedb.org/3";
export const API = "8a485d4552452fe87e04e972d00c1e64";
export const UP_TOP = () => {
  window.scrollTo(0, 0);
}